var Index_object_testimonials_slider = document.querySelector('.Index_object_testimonials_slider');
if (Index_object_testimonials_slider) {
    new Swiper('.Index_object_testimonials_slider', {
        loop: true,
        grabCursor: false,
        spaceBetween: 0,
        slidesPerGroup: 1,
        slidesPerView: 1,
        watchSlidesProgress: true,
        draggable: !0,
        autoHeight: !1,
        watchOverflow: !0,
        threshold: 10,
        mousewheel: {
            forceToAxis: !0
        },
        observer: true,
        observeParents: true,
        effect: "fade",
        speed: 300,
        fadeEffect: {
            crossFade: true,
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        breakpoints: {
            0: {
                freeMode: !1
            },
            750: {
            },
            990: {
            },
            1200: {
            },
            1440: {
            }
        }
    })
}

/* Popup */
function initVideoPopup() {

  /* ===============================
     OPEN POPUP & PLAY VIDEO
  =============================== */
  document.querySelectorAll(".testimonials_popup_open").forEach(el => {
    el.addEventListener("click", function () {

      const videoId = this.getAttribute("video_id");
      if (!videoId) return;

      /* ===============================
         PAUSE ALL PREVIOUS VIDEOS
      =============================== */
      document.querySelectorAll(".video_play_list_new video").forEach(v => {
        v.pause();
      });

      /* ===============================
         CLOSE ALL PREVIOUS POPUPS
      =============================== */
      document.querySelectorAll(".Testimonials_popup_new").forEach(popup => {
        popup.classList.remove("open");
      });

      const popup = document.querySelector("." + videoId + "_open");
      const overlay = document.querySelector(".testimonials_popup_overlay_new");
      const video = popup.querySelector("video");
      const playIconWrap = popup.querySelector(".video_play_icon_new");
      const playIconSvg = popup.querySelector("svg.play_icon");

      // Show popup & overlay
      popup.classList.add("open");
      overlay.classList.add("open");
      document.body.classList.add("testimonials_popup_is_open");

      // Load video source only once
      const videoURL = video.getAttribute("video_url");

      if (!video.getAttribute("src")) {
        video.setAttribute("src", videoURL);
      }

      // Play current video
      video.play();

      // Update play icons
      playIconWrap.classList.add("active");

      if (playIconSvg) {
        playIconSvg.style.display = "none";
      }
    });
  });

  /* ===============================
     MUTE / UNMUTE
  =============================== */

  document.querySelectorAll(".mute_video_popup").forEach(el => {
    el.addEventListener("click", function () {

      const popup = this.closest(".Testimonials_popup_new");

      this.classList.remove("active");

      popup.querySelector(".unmute_video_popup").classList.add("active");

      popup.querySelector("video").muted = true;
    });
  });

  document.querySelectorAll(".unmute_video_popup").forEach(el => {
    el.addEventListener("click", function () {

      const popup = this.closest(".Testimonials_popup_new");

      this.classList.remove("active");

      popup.querySelector(".mute_video_popup").classList.add("active");

      popup.querySelector("video").muted = false;
    });
  });

  /* ===============================
     CLOSE POPUP (BUTTON & OVERLAY)
  =============================== */

  document.querySelectorAll(".testimonials_popup_close").forEach(el => {
    el.addEventListener("click", closePopup);
  });

  document.querySelectorAll(".testimonials_popup_overlay_new").forEach(el => {
    el.addEventListener("click", closePopup);
  });

  function closePopup() {

    // Hide popups
    document.querySelectorAll(".Testimonials_popup_new").forEach(popup => {
      popup.classList.remove("open");
    });

    // Hide overlay
    document.querySelectorAll(".testimonials_popup_overlay_new").forEach(overlay => {
      overlay.classList.remove("open");
    });

    // Remove body class
    document.body.classList.remove("testimonials_popup_is_open");

    // Pause all videos
    document.querySelectorAll(".video_play_list_new video").forEach(video => {
      video.pause();

      // Optional reset
      // video.currentTime = 0;
    });

    // Reset play icon wrappers
    document.querySelectorAll(".video_play_icon_new").forEach(icon => {
      icon.classList.remove("active");
    });

    // Show play SVG icons again
    document.querySelectorAll("svg.play_icon").forEach(icon => {
      icon.style.display = "block";
    });
  }
}

initVideoPopup();